module.exports = __webpack_public_path__ + "assets/arcadeweb3.jpg?b7232f283119575d89c3be9fe9d6762c";